<div id="container">
    <ng-container *ngFor="let project of projectsArray">
        <div *ngIf="(project.subProject === '') && (project.archived===true || project.complete === true)">
            <app-project-tile [project]="project"  [username]="username" [projectRef]="project" [projectName]="project.title" [projectDescription]="project.description" [projectDeadline]="project.deadline" [projectID]="project.id" [numcollabs]="project.collaborators.length" [percentageComplete]="project.percentageComplete"></app-project-tile>
         </div>
    </ng-container>
</div>
